module.exports = __webpack_public_path__ + "media/img/private-venue/bg-hover-home-536840e6e426e5257413d22f2a79ec1b.png";